export const h ={
    "common": {
        "webSuffix": "-Tecnologia QIDI Tech QIDI",
        "email": "Caixa de correio",
        "password": "Senha",
        "verificationCode": "Código de verificação",
        "username": "Nome de usuário",
        "readAndAgree": "Eu concordo",
        "and": "E",
        "userAgreement": "Protocolo de usuário",
        "privacyPolicy": "Política de privacidade",
        "copy": "Propriedade de direitos de autor) 2025 QIDI reserva propriedade",
        "sendVerificationCode": "Envie código de verificação",
        "Sending": "Em envio",
        "tryAgainInSeconds": "Tente novamente em segundos",
        "userNameRequired": "Por favor introduz o nome do usuário",
        "passwordInputLabel": "Por favor, introduz uma senha",
        "checkPasswordInputLabel": "Por favor, introduz uma senha de confirmação",
        "userEmailRequired": "Por favor, introduz o endereço de correio electrónico",
        "userEmailInvalid": "Por favor, introduz o endereço correto de correio electrónico",
        "emailCodeRequired": "Por favor, introduz um código de verificação",
        "newPasswordInputLabel": "Por favor, introduz uma nova senha",
        "confirmPasswordInputLabel": "Por favor, introduz a senha novamente",
        "passwordMismatchErrorLabel": "As duas senhas de entrada são inconsistentes",
        "agreementRequired": "Por favor leia e concorda com o acordo",
        "tip": "Ponte",
        "tipAlreadyLogin": "Deteccionou que você se inscreveu para saltar para o centro de usuário",
        "tipWelcomeBack": "Bem-vindos de volta~",
        "tipDeleteAccountFail": "Falou em eliminar a conta, a interface de eliminação da conta está temporariamente fechada",
        "pleaseAgreeFirst": "Por favor concorda primeiro",
        "agree": "Concordou",
        "refuse": "Refusar",
        "tipNeedLogin": "Por favor, entra primeiro",
        "tipChangePasswordSuccess": "A senha foi modificada com sucesso para saltar para a página de login",
        "tipGetUserInfoSuccess": "Obter informações com sucesso",
        "tipGetUserInfoFail": "Falou em obter informação",
        "tipLoginOut": "Sair do login",
        "delete": "Eliminar",
        "back": "Voltar",
        "init": "Inicialização",

        "passwordInputLengthErrorLabel": "O comprimento da senha deve estar entre 6 e 20",
        "changePasswordFail": "Senha original errada",
        "tipDeleteAccountSuccess": "Eliminar a conta com sucesso",
        "emailCodeSentSuccess": "O código de verificação foi emitido",
        "emailCodeSentFail": "O código de verificação falhou",
        "emailLoginFail": "O código de verificação expirou",
        "passwordLoginFail": "Senha de login errada",
        "editUserInfoSuccess": "Modificar a informação do usuário com sucesso",
        "registerSuccess": "Registo bem sucedido",
        "registerFail": "Falou no registro",
        "registerEmailExistFail": "A caixa de correio já existe",

        "resMessageTip0": "Informação desconhecida",
        "resMessageTip1": "Senha errada",
        "resMessageTip2": "O comprimento da senha deve estar entre 6 e 20",
        "resMessageTip3": "Erro da conta",
        "resMessageTip4": "O código de verificação foi emitido",
        "resMessageTip5": "O código de verificação falhou",
        "resMessageTip6": "O código de verificação expirou",
        "resMessageTip7": "Senha errada",
        "resMessageTip8": "A senha não pode ser a mesma que a velha",
        "resMessageTip9": "A caixa de correio já existe",
        "resMessageTip10": "Registo bem sucedido",
        "resMessageTip11": "Falou no registro",
        "resMessageTip12": "Modificar a informação do usuário com sucesso",
        "resMessageTip13": "Falou em modificar a informação do usuário",
        "resMessageTip14": "Obter sucesso",
        "resMessageTip15": "Falou no conseguimento",
        "resMessageTip16": "A senha foi modificada com sucesso",
        "resMessageTip17": "Falou em modificar a senha",
        "resMessageTip18": "Reiniciar a senha com sucesso",
        "resMessageTip19": "Reiniciar a senha falhou",
        "resMessageTip20": "Enregistro bem sucedido",
        "resMessageTip21": "Falou no login",
        "resMessageTip22": "A conta foi eliminada com sucesso",
        "resMessageTip23": "Falou em eliminar a conta",
        "resMessageTip24": "Código de verificação errado",
        "noUserInfoError": "Erro de rede, por favor entra novamente"
    },
    "changePassword": {
        "newPassword": "Nova senha"
    },
    "deleteUser": {
        "tipDeleteUser": "Desculpe que você esteja indo Uma vez que sua conta seja eliminada, todos seus dados pessoais desaparecerão permanentemente e não podem ser recuperados",
        "accountDeletionTerms": "Cláusulas de eliminação da conta"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Recuperar a senha através do correio electrónico",
        "confirmPassword": "Confirmar a senha",
        "resettingPassword": "Reiniciar a senha",
        "resetting": "Reiniciar"
    },
    "login": {
        "passwordLogin": "Enregistro de senha",
        "verifyLogin": "Verificar o login",
        "accountRegistration": "Registração de contas",
        "forgotPassword": "Esqueça a senha",
        "login": "Entre",
        "localLogin": "Enregistro local",
        "loginOut": "Pub fora",
        "continueOnYourWay": "Continua ir"
    },
    "register": {
        "registerAnAccount": "Conta de conta registada",
        "register": "Registração"
    },
    "userCenter": {
        "personalInformation": "Dados pessoais",
        "modifyInformation": "Modificar informação",
        "changePassword": "Modificar a senha",
        "cancelAccount": "Cancelar a conta",
        "exitAccount": "Sair da conta de conta",
        "change": "Modificação",
        "maxCharLimitTip": "O comprimento do nome do usuário não pode exceder 10 personagens chineses",
    },
    "policies": {
        "deleteAccountPrivacy": "Eliminar o acordo de conta",
        "agreement": "Protocolo de uso",
        "privacyPolicy": "Política de privacidade"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Escolha seu país ou região",
        "recommendedVisits": "Acesso recomendado",
        "NorthAmerica": "América do Norte",
        "Europe": "Europa",
        "Asia": "Ásia",
        "Other": "Outros",
    }
}

export const aAndL ={
    "ar": {
        "Country": "Árabe",
        "Language": "Árabe"
    },
    "cs": {
        "Country": "Checa",
        "Language": "Ceco"
    },
    "de": {
        "Country": "Alemanha",
        "Language": "Alemão"
    },
    "en": {
        "Country": "Grã-Bretanha",
        "Language": "Inglês"
    },
    "es": {
        "Country": "Espanha",
        "Language": "Espanhol"
    },
    "fr": {
        "Country": "França",
        "Language": "Francês"
    },
    "he": {
        "Country": "Israel",
        "Language": "Hebreo"
    },
    "hu": {
        "Country": "Hungria",
        "Language": "Húngaro"
    },
    "it": {
        "Country": "Itália",
        "Language": "Italiano"
    },
    "ja": {
        "Country": "Japão",
        "Language": "Japão"
    },
    "ko": {
        "Country": "Coreia do Sul",
        "Language": "Coreano"
    },
    "nl": {
        "Country": "Países Baixos",
        "Language": "Holandesa"
    },
    "pt": {
        "Country": "Portugal",
        "Language": "Português"
    },
    "pt_BR": {
        "Country": "Portugal (Brasil)",
        "Language": "Brasil português"
    },
    "ru": {
        "Country": "Rússia",
        "Language": "Russo"
    },
    "sv": {
        "Country": "Suécia",
        "Language": "Sueco"
    },
    "tr": {
        "Country": "Turquia",
        "Language": "Turco"
    },
    "uk": {
        "Country": "Ucrânia",
        "Language": "Ucraniano"
    },
    "zh": {
        "Country": "China continental",
        "Language": "Chinês simplificado"
    },
    "zh_tw": {
        "Country": "Taiwan, China",
        "Language": "Chinês tradicional"
    },
    "Canada": {
        "Country": "Canadá",
        "Language": "Inglês"
    },
    "United_States": {
        "Country": "Estados Unidos",
        "Language": "Inglês"
    },
    "United_Kingdom": {
        "Country": "Grã-Bretanha",
        "Language": "Inglês"
    },
    "EU_Countries": {
        "Country": "Países da UE",
        "Language": "Inglês"
    },
    "Australia": {
        "Country": "Austrália",
        "Language": "Inglês"
    },
    "globalzh": {
        "Country": "Global",
        "Language": "Chinês simplificado"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Inglês"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/pt_BR.js